export default "__VITE_ASSET__CuvdeX46__"